// extracted by mini-css-extract-plugin
export default {"PriceWrapper":"ShippingCartItem_PriceWrapper__Sf0z1"};